import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const WorkbookUpstreamDatasourcesWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query WorkbookUpstreamDatasourcesWithoutPersonalSpaceQuery(
  $workbookVizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  workbooks(filter: { vizportalUrlId: $workbookVizportalUrlId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
